// Library chemistry of a capture kit (BED file) and whether Genesus can call variants on it.
//
// The backend reports both on every /bed/list row once it supports them:
//   chemistry   'hybrid_capture' | 'amplicon' | 'anchored_pcr'
//   own_calling { route, available, code, reason }  (reason is clinician text)
// Until then no row carries `chemistry`, nothing is sent and nothing changes on screen.

export const DEFAULT_CHEMISTRY = 'hybrid_capture'

export const CHEMISTRY_OPTIONS = Object.freeze([
  { value: 'hybrid_capture', label: 'Hybrid capture (probes)', short: 'Hybrid capture' },
  { value: 'amplicon', label: 'Amplicon (PCR primers)', short: 'Amplicon' },
  { value: 'anchored_pcr', label: 'Anchored PCR', short: 'Anchored PCR' },
])

const CHEMISTRY_VALUES = CHEMISTRY_OPTIONS.map((o) => o.value)

export const isChemistry = (value) => CHEMISTRY_VALUES.includes(value)

/** True once the kit list carries a chemistry, i.e. the backend accepts one on upload and edit. */
export const chemistrySupported = (bedFiles) =>
  Array.isArray(bedFiles) && bedFiles.some((bed) => bed && typeof bed === 'object' && 'chemistry' in bed)

/** The short label of a chemistry other than the default, else '' (hybrid capture reads as nothing). */
export const chemistryTag = (chemistry) => {
  if (!chemistry || chemistry === DEFAULT_CHEMISTRY) return ''
  return CHEMISTRY_OPTIONS.find((o) => o.value === chemistry)?.short || ''
}

export const chemistryLabel = (chemistry) =>
  CHEMISTRY_OPTIONS.find((o) => o.value === (chemistry || DEFAULT_CHEMISTRY))?.label || ''

const FALLBACK_UNAVAILABLE = 'Analysis cannot be started on this panel.'

/**
 * Why this kit cannot be analysed, as the server words it, or '' when it can (or the
 * backend says nothing about it).
 */
export const ownCallingUnavailableReason = (bed) => {
  const own = bed && bed.own_calling
  if (!own || typeof own !== 'object' || own.available !== false) return ''
  return (typeof own.reason === 'string' && own.reason.trim()) || FALLBACK_UNAVAILABLE
}

/** The upload form field, only when the backend accepts it: {} otherwise. */
export const chemistryField = (chemistry, supported) => (supported && isChemistry(chemistry) ? { chemistry } : {})
